import { InjectionToken, Type } from '@angular/core'

import {
  ClientStoreInterface,
  HttpRequestInterceptor,
  HttpResponseInterceptor,
  NomenclatorServiceInterface,
} from '@flowx/core-sdk'

import { NgSyncValidator } from '../utils/validators'

type ComponentConfig = Record<string, Type<any>>

export type CustomLoader = {
  actions?: Record<string, Type<any>>
  startProcess?: Type<any>
  reloadProcess?: Type<any>
  defaultAction?: Type<any>
  defaultUpload?: Type<any>
}

export const FLX_VALIDATORS_CONFIG = new InjectionToken<Record<string, NgSyncValidator>>(
  'FLX_VALIDATORS_CONFIG'
)
export const FLX_COMPONENTS_CONFIG = new InjectionToken<ComponentConfig>('FLX_COMPONENTS_CONFIG')
export const FLX_CLIENT_STORE_CONFIG = new InjectionToken<ClientStoreInterface>(
  'FLX_CLIENT_STORE_CONFIG'
)
export const FLX_NOMENCLATOR_CONFIG = new InjectionToken<NomenclatorServiceInterface>(
  'FLX_NOMENCLATOR_CONFIG2'
)
export const FLX_REQUEST_INTERCEPTORS_CONFIG = new InjectionToken<HttpRequestInterceptor[]>(
  'FLX_REQUEST_INTERCEPTORS_CONFIG'
)
export const FLX_RESPONSE_INTERCEPTORS_CONFIG = new InjectionToken<HttpResponseInterceptor[]>(
  'FLX_RESPONSE_INTERCEPTORS_CONFIG'
)
export const FLX_CUSTOM_LOADER_CONFIG = new InjectionToken<CustomLoader>('FLX_CUSTOM_LOADER_CONFIG')
